import apiClient from '@/services/ApiClient'

const state = () => ({})

const getters = {}

const actions = {
  uploadFile ({ commit }, { url, file }) {
    return apiClient.sendRequest(
      'POST',
      url,
      file,
      { header: { 'Content-Type': 'multipart/form-data' } }
    )
  }
}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
